export const CORE_FLIGHTS_CFAR_NAME = "core-flights-cfar";

export enum CoreFlightsCfarOffersComponents {
  CfarOfferSection = "CfarOfferSection",
  CfarOfferSectionBody = "CfarOfferSectionBody",
  CfarHowItWorksDialog = "CfarHowItWorksDialog",
  CfarFintechMarketplaceProduct = "CfarFintechMarketplaceProduct",
  CfarReturnFilterBanner = "CfarReturnFilterBanner",
  FlightCfarFareView = "FlightCfarFareView",
  HtsAirCfarFintechMarketplaceProduct = "HtsAirCfarFintechMarketplaceProduct",
  HtsAirCfarHowItWorksDialog = "HtsAirCfarHowItWorksDialog",
  HtsAirCfarOffersGroupSection = "HtsAirCfarOffersGroupSection",
}

export enum CoreFlightsCfarExerciseComponents {
  AirCfarExerciseGenericActionView = "AirCfarExerciseGenericActionView",
  AirCfarExerciseErrorExpired = "AirCfarExerciseErrorExpired",
  AirCfarExerciseErrorExercised = "AirCfarExerciseErrorExercised",
  AirCfarExerciseErrorUnknown = "AirCfarExerciseErrorUnknown",
  AirCfarExerciseErrorVoid = "AirCfarExerciseErrorVoid",
  AirCfarExerciseComplete = "AirCfarExerciseComplete",
  AirCfarExerciseLoadingScreen = "AirCfarExerciseLoadingScreen",
  AirCfarExerciseConfirmCancellation = "AirCfarExerciseConfirmCancellation",
  AirCfarExerciseNavWrapper = "AirCfarExerciseNavWrapper",
  AirCfarExercise = "AirCfarExercise",
  AirCfarExercisePage = "AirCfarExercisePage",
  // Cancel Quote Components
  AirCfarExerciseContent = "AirCfarExerciseContent",
  AirCfarGeneralError = "AirCfarGeneralError",
  AirCfarLoading = "AirCfarLoading",
  AirCfarDetails = "AirCfarDetails",
  // HTS
  HtsAirCfarCancelQuote = "HtsAirCfarCancelQuote",
  HtsAirCfarExerciseActionButtons = "HtsAirCfarExerciseActionButtons",
  HtsAirCfarNonExercisableContent = "HtsAirCfarNonExercisableContent",
}
